import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Row, Col, Button, Form, FormGroup } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
  InputText,
  Dropdown,
  Loading,
  Validations,
  VautoComplete,
  Valert,
  Vmodal,
  InputAmount,
} from "../components";
import { isLoggedIn, getLoggedInUser } from "../services/AuthenticationService";
import profileActions from "../actions/profileActions";
import subUserCreateActions from "../actions/subUserCreateActions";
import profileUpdateActions from "../actions/profileUpdateActions";
import {
  monthOptions as arrMonthOptions,
  getYearOptions,
  getMonthOptionsTrans,
} from "../components/componentsConstant";
import { USER_LANG } from "../actions/constant";
import "./styles/profile.css";
import "./styles/profileModern.css";
import i18n from "../i18n";
import i18next from "i18next";

// password validation
const min8 = Validations.min8;
const max15 = Validations.max15;
const minOneUppercase = Validations.min_one_uppercase;
const minOneNumber = Validations.min_one_number;
const minOneSpecial = Validations.min_one_special;
const passChecker = (value, old) => {
  var result = undefined;
  result = old ? undefined : i18n.t("profile.OLD_PASSWORD_FIELD_REQUIRED_TEXT");
  if (result) return result;
  result = min8(value);
  if (result) return result;
  result = minOneUppercase(value);
  if (result) return result;
  result = minOneNumber(value);
  if (result) return result;
  result = minOneSpecial(value);
  if (result) return result;
  result = max15(value);
  if (result) return result;
  return "";
};

const graduatePassChecker = (value) => {
  if (value) {
    var result = undefined;
    var final = "";
    result = min8(value);
    if (result) return result;
    result = minOneUppercase(value);
    if (result) return result;
    result = minOneNumber(value);
    if (result) return result;
    result = minOneSpecial(value);
    if (result) return result;
    result = max15(value);
    if (result) return result;
  }
  return "";
};

// new custom pass checker
let min8Checker;
let max15Checker;
let minOneUppercaseChecker;
let minOneLowercaseChecker;
let minOneNumberChecker;
let minOneSpecialChecker;

let customPassChecker = (value) => {
  min8Checker = value && Validations.min8(value) ? false : true;
  max15Checker = Validations.max15(value) ? false : true;
  minOneUppercaseChecker = Validations.min_one_uppercase(value) ? false : true;
  minOneLowercaseChecker = Validations.min_one_lowercase(value) ? false : true;
  minOneNumberChecker = Validations.min_one_number(value) ? false : true;
  minOneSpecialChecker = Validations.min_one_special(value) ? false : true;
};

class SubUserCreateForm extends Component {
  constructor(props) {
    super(props);
    this.vResetForm = this.vResetForm.bind(this);
    this.stateChanger = this.stateChanger.bind(this);
    this.passValidator = this.passValidator.bind(this);
    this.resetForgetPassword = this.resetForgetPassword.bind(this);
    this.state = {
      old_passwordValidator: "",
      new_passwordValidator: "",
      confirm_passwordValidator: "",
      allergenTAS: {},
      ethnicityTAS: {},
      showPassword: false,
      showNewPassword: false,
      showNewConfirmPassword: false,
    };
  }

  resetInputVisualState = (el) => {
    if (!el) return;
    // Clear value and blur to detach any active :autofill painting
    try { el.value = ""; } catch (e) {}
    try { el.blur(); } catch (e) {}
    // Flip type to reset browser's autofill rendering cache
    const origType = el.type;
    try {
      el.type = (origType === "password") ? "text" : origType;
      // force reflow
      void el.offsetWidth;
      el.type = (origType === "password") ? "password" : origType;
    } catch (e) {}
  };

  componentDidUpdate(prevProps) {
    // detect transition to "changePassword = true" (your disabled condition)
    const wasEnabled = !(prevProps.isDeleting || !prevProps.isEditing);
    const isNowDisabled = (this.props.isDeleting || !this.props.isEditing);
    if (isNowDisabled && wasEnabled) {
      // Old/New/Confirm have refs already in your code
      this.resetInputVisualState(this.old_password);
      this.resetInputVisualState(this.new_password);
      this.resetInputVisualState(this.confirm_password);
    }
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  stateChanger(key, value) {
    var data = {};
    data[key] = value;
    this.setState(data);
  }
  vResetForm() {
    this.props.reset();
  }
  resetForgetPassword() {
    this.props.change("new_password", "");
    this.props.change("confirm_password", null);
    this.props.change("old_password", "");
    this.setState({
      old_passwordValidator: "",
      new_passwordValidator: "",
      confirm_passwordValidator: "",
    });
  }
  passValidator(e) {
    // if (this.props.subUserCreateForm.new_password.length > 0) {
    //   this.setState({
    //     new_passwordValidator: passChecker(
    //       e.currentTarget.value,
    //       this.old_password.value
    //     ),
    //   });
    // }
    // if (
    //   this.props.subUserCreateForm.confirm_password &&
    //   e.currentTarget.value !== this.props.subUserCreateForm.confirm_password
    // ) {
    const newPass =
      (e &&
        e.currentTarget &&
        e.currentTarget.value !== undefined
          ? e.currentTarget.value
          : e &&
            e.target &&
            e.target.value !== undefined
          ? e.target.value
          : this.props.subUserCreateForm &&
            this.props.subUserCreateForm.new_password
          ? this.props.subUserCreateForm.new_password
          : "");

    const oldPass =
      this.props.subUserCreateForm &&
      this.props.subUserCreateForm.old_password
        ? this.props.subUserCreateForm.old_password
        : "";


    if (
      this.props.subUserCreateForm &&
      this.props.subUserCreateForm.new_password &&
      this.props.subUserCreateForm.new_password.length > 0
    ) {
      this.setState({
        new_passwordValidator: passChecker(newPass, oldPass),
      });
    }

    if (
      this.props.subUserCreateForm &&
      this.props.subUserCreateForm.confirm_password &&
      newPass !== this.props.subUserCreateForm.confirm_password
    ) {

      this.setState({
        confirm_passwordValidator: this.props.t(
          "reset.PASSWORD_CONFIRM_NOT_MATCH"
        ),
      });
    } else {
      this.setState({
        confirm_passwordValidator: "",
      });
    }
    // customPassChecker(e.currentTarget.value);
    customPassChecker(newPass);
  }
  checkConfirmPass(e) {
    // var val =
    //   this.new_password.value == undefined
    //     ? ""
    //     : this.new_password.value;
    // if (e.currentTarget.value != val) {

    const confirmPass =
      (e &&
        e.currentTarget &&
        e.currentTarget.value !== undefined
          ? e.currentTarget.value
          : e &&
            e.target &&
            e.target.value !== undefined
          ? e.target.value
          : this.props.subUserCreateForm &&
            this.props.subUserCreateForm.confirm_password
          ? this.props.subUserCreateForm.confirm_password
          : "");

    const newPass =
      this.props.subUserCreateForm &&
      this.props.subUserCreateForm.new_password
        ? this.props.subUserCreateForm.new_password
        : "";

    if (confirmPass !== newPass) {
      this.setState({
        confirm_passwordValidator: this.props.t(
          "reset.PASSWORD_CONFIRM_NOT_MATCH"
        ),
        new_passwordValidator: "",
      });
    } else {
      this.setState({ confirm_passwordValidator: "" });
    }
  }
  onAddAllergen() {
    let addFlag = true;
    let allergenList = this.props.subUserCreateForm.allergen || [];
    if (allergenList.length > 0) {
      allergenList.map((item) => {
        if (item._id === this.state.allergenTAS._id) {
          addFlag = false;
        }
      });
    }

    if (addFlag) {
      this.props.onChangeProfile({
        target: {
          name: "allergen",
          value: this.state.allergenTAS,
        },
      });
      this.setState({ allergenTAS: {} });
    } else {
      this.props.allergenDup.changeStatus();
    }
  }
  onAddEthnicity() {
    let addFlag = true;
    let ethnicityList = this.props.subUserCreateForm.ethnicity || [];
    if (ethnicityList.length > 0) {
      ethnicityList.map((item) => {
        if (item._id === this.state.ethnicityTAS._id) {
          addFlag = false;
        }
      });
    }
    if (addFlag) {
      this.props.onChangeProfile({
        target: {
          name: "ethnicity",
          value: this.state.ethnicityTAS,
        },
      });
      this.setState({ ethnicityTAS: {} });
    } else {
      this.props.allergenDup.changeStatus();
    }
  }

  handleLangChange(e) {
    const selectedLang = USER_LANG.filter((language) => {
      return language.value == e.target.value;
    });
    this.props.languageSelected(selectedLang);
  }

  render() {
    const t = this.props.t;
    const yearOptions = getYearOptions();
    const monthOptions = getMonthOptionsTrans(arrMonthOptions);
    const allergenObject =
      this.props.subUserCreateForm.allergen &&
        this.props.subUserCreateForm.allergen.length > 0
        ? this.props.subUserCreateForm.allergen
        : null;
    const ethnicityObject =
      this.props.subUserCreateForm.ethnicity &&
        this.props.subUserCreateForm.ethnicity.length > 0
        ? this.props.subUserCreateForm.ethnicity
        : null;
    // let ethnicityOptions = this.props.ethnicities;
    const changePassword = this.props.isDeleting || !this.props.isEditing;
    var formTitle = this.props.isEditing
      ? t("profile.UPDATE_FORM_TITLE")
      : t("profile.NEW_SUBUSER_TITLE");
    if (this.props.selectedUser) {
      formTitle = `${formTitle} ${this.props.selectedUser.first_name} ${this.props.selectedUser.last_name}`;
    }

    const isValidNumber = (value) => {
      return /^(\d+(\.\d+)?|\.\d+)$/.test(value);
    };

    return (
      <div>
        <Form
          onSubmit={this.props.handleSubmit}
          ref="SUform"
          autoComplete="off"
        >
          <h6
            style={{
              wordBreak: "break-all",
            }}
          >
            {formTitle}
          </h6>
          <Vmodal
            zIndex={11}
            displayStatus={this.props.ethModalStatus}
            data={
              <div style={{ minWidth: 300, minHeight: 300 }}>
                <h5 style={{ paddingLeft: 5 }}>{t("signUp.ETHNICITY")}</h5>
                <div
                  className={`grayList ingredient-list `}
                  style={{ flex: 1 }}
                >
                  {!ethnicityObject ? (
                    <div className="usersItem">
                      <Row className="wrapper">
                        <Col>
                          <span className="desc" />
                          {this.props.t("general.INGREDIENTS_EMPTY")}
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className="usersItem">
                      {ethnicityObject.map((item, index) => {
                        return (
                          <Row
                            className="wrapper"
                            style={{ marginBottom: 3 }}
                            key={index}
                          >
                            <Col xs="11" style={{ paddingLeft: 4 }}>
                              <span className="desc" />
                              {item.name}
                            </Col>
                            <Col xs="1" className="p-0">
                              <i
                                className="far fa-trash-alt deleteIcon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.props.onDelEth(item);
                                }}
                              />
                            </Col>
                          </Row>
                        );
                      })}
                    </div>
                  )}
                </div>
                <FormGroup>
                  <Field
                    name="ethnicityTAS"
                    component={VautoComplete}
                    placeholder={t("general.ITEM_INPUT_TEXT")}
                    onChangeText={(val) => {
                      this.setState({ ethnicityTAS: { name: val } });
                    }}
                    onSelect={(val) => this.setState({ ethnicityTAS: val })}
                    val={this.state.ethnicityTAS.name}
                    category={"21"}
                    level="111111"
                    showHistory={false}
                  />
                </FormGroup>
                <FormGroup>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{
                      padding: "4px 10px",
                      float: "right",
                      marginLeft: 6,
                    }}
                    onClick={() => {
                      this.props.ethModal();
                      this.setState({ ethnicityTAS: {} });
                    }}
                  >
                    {t("general.DONE_BUTTON")}
                  </button>
                </FormGroup>
                <FormGroup>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ padding: "4px 10px", float: "right" }}
                    onClick={() => {
                      this.onAddEthnicity();
                    }}
                    disabled={this.state.ethnicityTAS._id ? false : true}
                    reseter={this.props.amountReseter}
                  >
                    {t("general.ADD_BUTTON_TEXT")}
                  </button>
                </FormGroup>
              </div>
            }
            closeFunc={() => {
              this.props.ethModal();
              this.setState({ ethnicityTAS: {} });
            }}
          />
          <Vmodal
            zIndex={11}
            displayStatus={this.props.algModalStatus}
            data={
              <div style={{ minWidth: 300, minHeight: 300 }}>
                <h5 style={{ padding: 5 }}>
                  {t("profile.ALLERGEN_MODAL_TITLE")}
                </h5>
                <div
                  className={`grayList ingredient-list `}
                  style={{ flex: 1 }}
                >
                  {!allergenObject ? (
                    <div className="usersItem">
                      <Row className="wrapper">
                        <Col>
                          <span className="desc" />
                          {this.props.t("general.INGREDIENTS_EMPTY")}
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className="usersItem">
                      {allergenObject.map((item, index) => {
                        return (
                          <Row
                            className="wrapper"
                            style={{ marginBottom: 3 }}
                            key={index}
                          >
                            <Col xs="11" style={{ paddingLeft: 4 }}>
                              <span className="desc" />
                              {item.name ? item.name : item.fullname}
                            </Col>
                            <Col xs="1" className="p-0">
                              <i
                                className="far fa-trash-alt deleteIcon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.props.onDelAllergen(item);
                                }}
                              />
                            </Col>
                          </Row>
                        );
                      })}
                    </div>
                  )}
                </div>
                <FormGroup>
                  <Field
                    name="allergenTAS"
                    component={VautoComplete}
                    placeholder={t("general.ITEM_INPUT_TEXT")}
                    onChangeText={(val) => {
                      this.setState({ allergenTAS: { fullname: val } });
                    }}
                    onSelect={(val) => this.setState({ allergenTAS: val })}
                    val={this.state.allergenTAS.fullname}
                    category={"32"}
                    level={"1000000"}
                    allergen={true}
                    showHistory={false}
                  />
                </FormGroup>
                <FormGroup>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{
                      padding: "4px 10px",
                      float: "right",
                      marginLeft: 6,
                    }}
                    onClick={() => {
                      this.props.algModal();
                      this.setState({ allergenTAS: {} });
                    }}
                  >
                    {t("general.DONE_BUTTON")}
                  </button>
                </FormGroup>
                <FormGroup>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ padding: "4px 10px", float: "right" }}
                    onClick={() => {
                      this.onAddAllergen();
                    }}
                    disabled={this.state.allergenTAS._id ? false : true}
                    reseter={this.props.amountReseter}
                  >
                    {t("general.ADD_BUTTON_TEXT")}
                  </button>
                </FormGroup>
              </div>
            }
            closeFunc={() => {
              this.props.algModal();
              this.setState({ allergenTAS: {} });
            }}
          />
          <FormGroup row>
            <Col>
              <Field
                component={InputText}
                type="text"
                name="first_name"
                ref="first_name"
                placeholder={t("signUp.FIRST_NAME")}
                validate={Validations.required}
                onChange={this.props.onChangeProfile}
              />
            </Col>
            <Col>
              <Field
                component={InputText}
                type="text"
                name="last_name"
                placeholder={t("signUp.LAST_NAME")}
                validate={Validations.required}
                onChange={this.props.onChangeProfile}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                name="birthMonth"
                component={Dropdown}
                options={monthOptions}
                className="birthMonth"
                placeholder={t("signUp.MONTH")}
                validate={Validations.select_required}
                onChange={this.props.onChangeProfile}
                disabled={this.props.isEditing ? true : false}
              />
            </Col>
            <Col>
              <Field
                name="birthYear"
                component={Dropdown}
                options={yearOptions}
                className="birthYear"
                placeholder={t("signUp.YEAR")}
                validate={Validations.select_required}
                onChange={this.props.onChangeProfile}
                disabled={this.props.isEditing ? true : false}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                name="group"
                component={Dropdown}
                options={t("USER_GROUP", {
                  returnObjects: true,
                })}
                className="group"
                placeholder={t("profile.GROUP")}
                validate={Validations.select_required}
                onChange={this.props.onChangeProfile}
                disabled={this.props.isEditing ? true : false}
              />
            </Col>
            <Col>
              <Field
                name="gender"
                component={Dropdown}
                options={[
                  { label: i18n.t("general.MALE_GENDER_TEXT"), value: "1" },
                  { label: i18n.t("general.FEMALE_GENDER_TEXT"), value: "2" },
                  { label: i18n.t("general.OTHER_GENDER_TEXT"), value: "3" },
                ]}
                className="gender"
                placeholder={t("signUp.GENDER")}
                validate={Validations.select_required}
                onChange={this.props.onChangeProfile}
                disabled={this.props.isEditing ? true : false}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                component={InputAmount}
                name="weight"
                placeholder={t("profile.WEIGHT")}
                onKeyUp={(e) => this.props.onChangeProfile(e)}
                amounNewValue={this.props.subUserCreateForm.weight}
                pattern="[0-9.]*"
              />
              <span
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "13px",
                  color: "#999",
                }}
              >
                {t("profile.WEIGHT_UNIT_TABLE")}
              </span>
            </Col>
            <Col>
              <Field
                component={InputAmount}
                name="height"
                placeholder={t("profile.HEIGHT")}
                onKeyUp={(e) => this.props.onChangeProfile(e)}
                amounNewValue={this.props.subUserCreateForm.height}
                pattern="[0-9.]*"
              />
              <span
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "13px",
                  color: "#999",
                }}
              >
                {t("profile.HEIGHT_UNIT_TABLE")}
              </span>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12}>
              <Field
                component={InputText}
                type="text"
                name="allergen_name"
                placeholder={t("profile.ALLERGEN")}
                readonly={true}
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  paddingLeft: "7px",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
                input={{
                  value: this.props.subUserCreateForm.allergen_name,
                  onFocus: this.props.algModal,
                }}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                component={InputText}
                type="text"
                name="ethnicity_name"
                placeholder={t("signUp.ETHNICITY")}
                disabled={
                  this.props.subUserCreateForm.group == "1100" ? false : true
                }
                readonly={true}
                input={{
                  value: this.props.subUserCreateForm.ethnicity_name,
                  onFocus: this.props.ethModal,
                }}
                style={
                  this.props.subUserCreateForm.group == "1100"
                    ? {
                      backgroundColor: "#fff",
                      color: "#000",
                      paddingLeft: "7px",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }
                    : null
                }
                reseter={this.props.amountReseter}
              />
            </Col>
            <Col>
              <Field
                name="lang"
                component={Dropdown}
                options={USER_LANG}
                className="lang"
                disabled={changePassword}
                placeholder={t("profile.LANGUAGE")}
                onChange={(e) => {
                  this.handleLangChange(e);
                }}
              />
            </Col>
          </FormGroup>
          <div>
            <FormGroup>
              <Field
                key={`old_${changePassword ? "disabled" : "enabled"}`}
                component={InputText}
                autoComplete="new-password"
                type={this.state.showPassword ? "text" : "password"}
                name="old_password"
                disabled={changePassword}
                placeholder={t("reset.OLD_PASSWORD_TITLE")}
                ref="old_password"
                onChange={this.props.onChangeProfile}
                style={{ paddingRight: 36 }}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div></div>
                <div
                  style={{
                    marginTop: "-25px",
                    display: "flex",
                    cursor: "pointer",
                    marginRight: "10px",
                    width: "20px",
                    height: "25px",
                  }}
                  onClick={
                    changePassword
                      ? null
                      : () =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                  }
                >
                  <i
                    className={
                      this.state.showPassword
                        ? "far fa-eye"
                        : "far fa-eye-slash"
                    }
                    style={{
                      color: changePassword ? "#999" : "#077bff",
                    }}
                  />
                </div>
              </div>
            </FormGroup>
            <FormGroup row>
              <Col>
                <Field
                  key={`new_${changePassword ? "disabled" : "enabled"}`}
                  component={InputText}
                  type={this.state.showNewPassword ? "text" : "password"}
                  name="new_password"
                  disabled={changePassword}
                  placeholder={t("reset.NEW_PASSWORD")}
                  onChange={(e) => {
                    // this.props.onChangeProfile(e),
                    // this.passValidator(e);

                    // keep reducer contract: expects action.event.target.name/value
                    if (e && e.target) this.props.onChangeProfile(e);
                    this.passValidator(e);
                  }}
                  ref="new_password"
                  style={{
                    paddingRight: 36,
                    boxShadow:
                      this.props.subUserCreateForm.new_password &&
                      this.state.new_passwordValidator &&
                      "none",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "11px",
                    cursor: "pointer",
                  }}
                  onClick={
                    changePassword
                      ? null
                      : () =>
                        this.setState({
                          showNewPassword: !this.state.showNewPassword,
                        })
                  }
                >
                  <i
                    className={
                      this.state.showNewPassword
                        ? "far fa-eye"
                        : "far fa-eye-slash"
                    }
                    style={{
                      color: changePassword ? "#999" : "#077bff",
                    }}
                  />
                </div>
                {this.props.subUserCreateForm.new_password && (
                  <div className="invalid-feedback">
                    <span
                      style={{
                        color: "#212529",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_PASSWORD")}
                    </span>
                    <span
                      style={{
                        color:
                          this.props.subUserCreateForm.new_password &&
                            min8Checker
                            ? "#008000"
                            : "#DC3545",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_MIN_8")}
                    </span>
                    <span
                      style={{
                        color:
                          this.props.subUserCreateForm.new_password &&
                            minOneUppercaseChecker
                            ? "#008000"
                            : "#DC3545",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_MIN_UPPERCASE")}
                    </span>
                    <span
                      style={{
                        color:
                          this.props.subUserCreateForm.new_password &&
                            minOneLowercaseChecker
                            ? "#008000"
                            : "#DC3545",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_MIN_LOWERCASE")}
                    </span>
                    <span
                      style={{
                        color:
                          this.props.subUserCreateForm.new_password &&
                            minOneNumberChecker
                            ? "#008000"
                            : "#DC3545",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_MIN_NUMBER")}
                    </span>
                    <span
                      style={{
                        color:
                          this.props.subUserCreateForm.new_password &&
                            minOneSpecialChecker
                            ? "#008000"
                            : "#DC3545",
                      }}
                    >
                      {i18n.t("validations.VALIDATE_MIN_SPECIAL_CHARACTER")}
                    </span>
                  </div>
                )}
              </Col>
              <Col>
                <Field
                  key={`confirm_${changePassword ? "disabled" : "enabled"}`}
                  component={InputText}
                  type={this.state.showNewConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  disabled={changePassword}
                  placeholder={t("reset.NEW_PASSWORD_CONFIRM")}
                  ref="confirm_password"
                  onChange={(e) => {
                    // this.props.onChangeProfile(e), this.checkConfirmPass(e);
                    if (e && e.target) this.props.onChangeProfile(e);
                    this.checkConfirmPass(e);
                  }}
                  style={{
                    paddingRight: 36,
                    boxShadow:
                      this.props.subUserCreateForm.confirm_password &&
                      this.state.confirm_passwordValidator &&
                      "none",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "11px",
                    cursor: "pointer",
                  }}
                  onClick={
                    changePassword
                      ? null
                      : () =>
                        this.setState({
                          showNewConfirmPassword:
                            !this.state.showNewConfirmPassword,
                        })
                  }
                >
                  <i
                    className={
                      this.state.showNewConfirmPassword
                        ? "far fa-eye"
                        : "far fa-eye-slash"
                    }
                    style={{
                      color: changePassword ? "#999" : "#077bff",
                    }}
                  />
                </div>
                {this.props.subUserCreateForm.confirm_password &&
                  this.state.confirm_passwordValidator ? (
                  <div className="invalid-feedback">
                    {this.state.confirm_passwordValidator}
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </FormGroup>
          </div>
        </Form>
        {/* <FormGroup> */}
        <div className="submit2 row justify-content-between">
          {!this.props.isEditing && (
            <div className="col">
              <Button
                disabled={this.props.disabled.addBtn}
                color="primary"
                onClick={this.props.onSubmit}
              >
                {t("general.CREATE")}
              </Button>
            </div>
          )}
          {this.props.isEditing && (
            <div className="col">
              <Button
                disabled={
                  this.props.checkPassword &&
                    this.props.subUserCreateForm.first_name &&
                    this.props.subUserCreateForm.last_name &&
                    isValidNumber(this.props.subUserCreateForm.weight) &&
                    isValidNumber(this.props.subUserCreateForm.height) &&
                    min8Checker &&
                    minOneLowercaseChecker &&
                    minOneNumberChecker &&
                    minOneSpecialChecker &&
                    minOneUppercaseChecker &&
                    this.props.subUserCreateForm.new_password ==
                    this.props.subUserCreateForm.confirm_password
                    ? false
                    : this.props.disabled.addBtn
                }
                color="primary"
                onClick={this.props.onSubmit}
              >
                {t("profile.UPDATE_FORM_TITLE")}
              </Button>
            </div>
          )}
          {this.props.isDeleting && (
            <div className="col">
              <Button
                type="button"
                color="primary"
                onClick={this.props.onGraduate}
                disabled={this.props.disabled.gradBtn}
              >
                {t("profile.GRADUATE_BUTTON_TITLE")}
              </Button>
            </div>
          )}
          <div className="col">
            <button
              type="button"
              className="btn btn-primary btnWide"
              onClick={this.props.onCancel}
              disabled={this.props.disabled.clearBtn ? "disabled" : ""}
            >
              {t("general.CLEAR")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
SubUserCreateForm = reduxForm({
  form: "formSubUserCreate",
  enableReinitialize: true,
  touchOnBlur: false,
})(SubUserCreateForm);
SubUserCreateForm = connect((state) => ({
  initialValues: state.profile.subUserCreateForm,
}))(SubUserCreateForm);

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedUserId: null,
      algModalStatus: false,
      ethModalStatus: false,
      gradMail: "",
      gradPassword: "",
      gradModal: false,
      updateLangModal: false,
      userPass: "",
      isSelfDelete: false,
      showPassword: false,
      showPasswordError: false,
      showGradPass: false,
      selectedUser: {},
      gradPassFieldId: `grad_pass_${Date.now()}`,
      gradMailFieldId: `grad_mail_${Date.now()}`,
      deletePassFieldId: `del_pass_${Date.now()}`,
      deleteModal: false,
    };
    this.cancelClicked = this.cancelClicked.bind(this);
    this.algModal = this.algModal.bind(this);
  }
  componentWillMount() {
    this.loggedInUser = getLoggedInUser();
    this.props.setDefaultState();
    // Check if login user
    if (isLoggedIn()) {
      this.props.subUserCreateInitialization(this.loggedInUser._id);
      this.setState({ selectedUserId: this.loggedInUser._id });
    } else {
      this.props.history.push("/");
    }
    this.setState({
      allUsers: null,
    });
  }
  componentDidMount() {
    // Check if login user
    if (!isLoggedIn()) {
      this.props.history.push("/");
    } else {
      this.props.getUserWithMainUserAndSubUsers(this.loggedInUser._id);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // When the "registered email" Valert turns on, ensure the grad modal is not shown in the background because it looks ugly and overlapped.
    if (this.props.emailError && !prevProps.emailError) {
      if (this.state.gradModal) {
        // Close the grad modal WITHOUT invoking closeFunc (which clears gradMail)
        this.setState({ gradModal: false });
      }
    }

    // When the "graduated successfully" Valert turns on, ensure the grad modal is not shown in the background because it looks ugly and overlapped.
    if (this.props.gradSuccess && !prevProps.gradSuccess) {
      if (this.state.gradModal || this.state.gradMail || this.state.gradPassword) {
        // Close the grad modal WITHOUT invoking closeFunc (which clears gradMail)
        this.setState({ gradModal: false, gradMail: "", gradPassword: "" });
      }
    }

    // When grad modal just opened, refresh input id to defeat autofill paint cache
    if (this.state.gradModal && !prevState.gradModal) {
      // refresh the id to defeat password-manager heuristics
      this.setState({
        gradPassFieldId: `grad_pass_${Date.now()}`,
        gradMailFieldId: `grad_mail_${Date.now()}`,
      });
      // }, () => {
      //   setTimeout(() => {
      //     const el = document.getElementById(this.state.gradPassFieldId);
      //     const mailEl = document.getElementById(this.state.gradMailFieldId);

      //     if (!el) return;
      //     try { el.value = ""; } catch (e) {}
      //     // same type flip trick as above to reset autofill paint (fixes FF yellow)
      //     try {
      //       const origType = el.type;
      //       el.type = (origType === "password") ? "text" : origType;
      //       void el.offsetWidth;
      //       el.type = (origType === "password") ? "password" : origType;
      //     } catch (e) {}
      //     try { el.blur(); } catch (e) {}

      //   }, 0);
      // });
    }

    // When delete modal just opened, refresh input id to defeat autofill paint cache
    if (this.state.deleteModal && !prevState.deleteModal) {
      this.setState({ deletePassFieldId: `del_pass_${Date.now()}` });
    }

  }
  algModal() {
    this.setState({ algModalStatus: !this.state.algModalStatus });
  }
  ethModal() {
    this.setState({ ethModalStatus: !this.state.ethModalStatus });
  }
  profileChange(e) {
    this.setState({ selectedUserId: e.target.value });
    this.props.getUserWithMainUserAndSubUsers(
      e.target.value,
      this.loggedInUser._id
    );
  }

  userItemOnClick(index) {
    let subUserInfo = this.props.subUserCreateForm;
    this.FormRef.stateChanger("new_passwordValidator", "");
    const User = this.props.allUsers[index];

    if (
      subUserInfo &&
      this.props.selectedIndex === -1 &&
      !this.props.disabled.addBtn
    ) {
      this.unsavedNewSubUser.changeStatus();
    } else if (
      this.props.selectedIndex === -1 &&
      this.props.disabled.addBtn &&
      (subUserInfo.first_name ||
        subUserInfo.last_name ||
        (subUserInfo.birthMonth && subUserInfo.birthMonth != "null") ||
        (subUserInfo.birthYear && subUserInfo.birthYear != "null") ||
        (subUserInfo.group && subUserInfo.group != "null") ||
        (subUserInfo.gender && subUserInfo.gender != "null") ||
        subUserInfo.weight ||
        subUserInfo.height ||
        (subUserInfo.allergen && subUserInfo.allergen.length > 0) ||
        (subUserInfo.ethnicity && subUserInfo.ethnicity.length > 0))
    ) {
      this.incompleteNewUser.changeStatus();
    } else if (this.props.profileNotUpdated) {
      this.unsavedCurrentItem.changeStatus();
    } else {
      if (User.isSelected) {
        this.setState({ selectedUserId: null });
        User.isSelected = false;
      } else {
        this.setState({ selectedUserId: User._id, selectedUser: User });
        User.isSelected = true;
      }
      this.props.editUserItem(index, this.props.selectedIndex, User);
    }
    this.itemIndex = index;
  }
  userItemOnPosClick() {
    this.FormRef.stateChanger("new_passwordValidator", "");
    this.FormRef.stateChanger("confirm_passwordValidator", "");
    const User = this.props.allUsers[this.itemIndex];
    if (User.isSelected) {
      this.setState({ selectedUserId: null });
      User.isSelected = false;
    } else {
      this.setState({ selectedUserId: User._id });
      User.isSelected = true;
    }
    this.props.editUserItem(this.itemIndex, this.props.selectedIndex, User);
  }
  handleSubmit(values) {
    values = this.props.subUserCreateForm;
    if (!this.noValidation) {
    }
    this.noValidation = false;
    const mainUser = this.props.user;
    const newUser = values;
    newUser.birthday = {
      month: parseInt(newUser.birthMonth),
      year: parseInt(newUser.birthYear),
    };
    newUser.first_name = newUser.first_name.trim();
    newUser.last_name = newUser.last_name.trim();
    this.props
      .subUserCreateSubmit(this.loggedInUser._id, newUser)
      .catch(() => { /* swallow to avoid unhandled rejection UI crash */ });
  }
  handleSubmitUpdate(values) {
    values = this.props.subUserCreateForm;
    var baseUser = getLoggedInUser();
    let userForm = values;

    let user = { ...userForm };

    user.birthday = {
      month: parseInt(user.birthMonth),
      year: parseInt(user.birthYear),
    };
    user.first_name = user.first_name.trim();
    user.last_name = user.last_name.trim();
    this.props
      .updateProfile(user, baseUser, this.props.match.params.id)
      .then(() => {
        if (userForm.old_password) {
          var passCheck = passChecker(
            userForm.new_password,
            userForm.old_password
          );
          if (!userForm.new_password) {
            this.FormRef.stateChanger(
              "new_passwordValidator",
              "Please fill New Password."
            );
          } else if (passCheck) {
            this.FormRef.stateChanger("new_passwordValidator", passCheck);
          } else if (!userForm.confirm_password) {
            this.FormRef.stateChanger(
              "confirm_passwordValidator",
              this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH")
            );
          } else if (userForm.new_password !== userForm.confirm_password) {
            this.FormRef.stateChanger(
              "confirm_passwordValidator",
              this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH")
            );
          } else {
            const currUser = baseUser;
            values.email = currUser.email;
            this.props.changePasswordSubmit(values);
          }
        }
      });
    if (
      this.props.subUserCreateForm.selectedLanguage &&
      this.props.subUserCreateForm.selectedLanguage != "null"
    ) {
      localStorage.setItem(
        "i18nextLng",
        this.props.subUserCreateForm.selectedLanguage
      );
    }
  }
  cancelClicked() {
    this.props.resetPage();
  }
  showSelectedUser() {
    var user = this.props.allUsers.find((value) => {
      return value.isSelected;
    });
    return user;
  }
  onDelEth(item) {
    this.EthDelitem = item;
    this.EthDelAlert.changeStatus();
  }
  onDelAllergen(item) {
    this.AlgDelitem = item;
    this.AlgDelAlert.changeStatus();
  }
  onGraduate = () => {
    this.setState({ gradModal: true });
  };
  resetForgetPassword() { }

  handleDeleteUser(id) {
    // Figure out who is currently selected BEFORE we overwrite state
    const current = this.showSelectedUser();
    const isSameAsSelected = current && current._id === id;
    const isSelfDelete = this.props.mainUser._id === id;

    // - Unsaved edits while editing an existing profile
    const hasUnsavedEdits = this.props.isEditing && this.props.profileNotUpdated;
    // - Unsaved *new* profile: only if firstChange is true AND the Clear button is enabled
    //   (enabled => there is something to clear => at least one field is filled)
    const hasUnsavedNewProfile =
      !this.props.isEditing && this.props.firstChange && !this.props.disabled.clearBtn;
    const shouldShowUnsavedPrompt = hasUnsavedEdits || hasUnsavedNewProfile;

    // keep these in state as before
    this.setState({ selectedUserId: id, isSelfDelete, showPassword: false, showPasswordError: false, userPass: "" });

    // If deleting the SAME user being edited AND there are unsaved edits,
    // skip "Current Profile not Updated" and go straight to the Not Recoverable Warning.
    if (this.props.profileNotUpdated && isSameAsSelected) {
      this.showDeleteUserRef.changeStatus();      // Not Recoverable Warning
      return;
    }

    // Route based on actual unsaved state
    if (shouldShowUnsavedPrompt) {
      // Show "Current/New Profile not Saved" first
      this.deleteValert.changeStatus();
    } else {
      // Nothing filled for new profile (or no unsaved edits) → jump to Not Recoverable Warning
      this.showDeleteUserRef.changeStatus();
    }
  }

  async onConfirmDeleteUser() {
    this.setState({ showPasswordError: false, loading: true });
    const isSelf = this.state.isSelfDelete;

    try {
      if (isSelf) {
        // delete user
        await this.props.deleteUserSubmit(
          this.props.mainUser._id,
          this.state.userPass
        );
      } else {
        // delete sub user
        this.FormRef.vResetForm();
        await this.props.subUserDeleteSubmit(
          this.props.mainUser._id,
          this.state.selectedUserId,
          this.state.userPass
        );
      }
      this.setState({ userPass: "", loading: false });
      this.closeDeleteModal();
      
    } catch (e) {
      this.setState({ showPasswordError: true, loading: false });
    }
  }
  handleRegisteredEmailPromptOk = () => {
    // keep the filled inputs intact; just bring the modal back
    this.setState({ gradModal: true });
    // if you're toggling this via a redux flag, clear it so the prompt hides
    this.props.clearPrompt && this.props.clearPrompt();
  };

  openDeleteModal = () => this.setState({ deleteModal: true, showPasswordError: false });
  closeDeleteModal = () => this.setState({ deleteModal: false, showPasswordError: false, userPass: "" });

  render() {
    const {
      t,
      mainUser,
      ethnicities,
      locations,
      allUsers,
      isEditing,
      subUserCreateForm,
      onChangeProfile,
      disabled,
      optionSelected,
      isLoading,
      profileSelected,
    } = this.props;
    const { loading } = this.state;

    let languageUpdate = localStorage.getItem("languageUpdate");

    const selectedUser = this.showSelectedUser();
    const isDeleting = selectedUser && selectedUser._id != mainUser._id;

    return (
      <div className="vPage profile-page profile-modern">
        <Loading isLoading={this.props.isUpdating || isLoading || loading} />
        <Vmodal
          zIndex={9}
          displayStatus={this.state.gradModal}
          data={
            <form autoComplete="off">

              {/* // marginLeft: 15, marginRight: 15, paddingTop: 20 */}
              <div style={{ width: 350, paddingTop: 25 }}>

                {/* Title */}
                <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                  {this.props.t("profile.GRADUATE_CONFIRM_TITLE")}
                </h4>

                {/* Body text */}
                <p style={{ margin: "0 0 16px 0", lineHeight: 1.4 }}>
                  {this.props.t("profile.GRADUATE_CONFIRM_TEXT")}
                </p>
              </div>
              
              <div className="row mb-2">
                <div className="col">
                  <InputText
                    key={this.state.gradMailFieldId}
                    id={this.state.gradMailFieldId}
                    type="text"
                    placeholder={t("profile.GRAD_EMAIL_PLACEHOLDER")}
                    invalid={Validations.email(this.state.gradMail)}
                    input={{
                      onChange: (e) => this.setState({ gradMail: e.target.value }),
                      name: "gradMail",
                      value: this.state.gradMail,
                      autoComplete: "off",
                      autoCapitalize: "off",
                      autoCorrect: "off",
                      spellCheck: false,
                    }}
                    meta={{
                      touched: true,
                      error: Validations.email(this.state.gradMail),
                    }}
                    style={{
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      backgroundImage: "none",
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col" style={{ position: "relative" }}>
                  <InputText
                    key={this.state.gradPassFieldId}
                    id={this.state.gradPassFieldId}
                    type={this.state.showGradPass ? "text" : "password"}
                    placeholder={t("profile.TEMPORARY_PASSWORD_PLACEHOLDER")}
                    invalid={graduatePassChecker(this.state.gradPassword)}
                    input={{
                      onChange: (e) =>
                        this.setState({ gradPassword: e.target.value }),
                      name: "gradPassword",
                      value: this.state.gradPassword,
                      autoComplete: "new-password",
                      autoCapitalize: "off",
                      autoCorrect: "off",
                      spellCheck: false,
                    }}
                    meta={{
                      touched: true,
                      error:
                        this.state.gradPassword &&
                        customPassChecker(this.state.gradPassword),
                    }}
                    style={{
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      backgroundImage: "none",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({ showGradPass: !this.state.showGradPass })
                    }
                  >
                    <i
                      className={
                        this.state.showGradPass
                          ? "far fa-eye"
                          : "far fa-eye-slash"
                      }
                      style={{
                        color: "#077bff",
                      }}
                    />
                  </div>
                  {this.state.gradPassword && (
                    <div className="invalid-feedback">
                      <span
                        style={{
                          color: "#212529",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_PASSWORD")}
                      </span>
                      <span
                        style={{
                          color:
                            this.state.gradPassword && min8Checker
                              ? "#008000"
                              : "#DC3545",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_MIN_8")}
                      </span>
                      <span
                        style={{
                          color:
                            this.state.gradPassword && minOneUppercaseChecker
                              ? "#008000"
                              : "#DC3545",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_MIN_UPPERCASE")}
                      </span>
                      <span
                        style={{
                          color:
                            this.state.gradPassword && minOneLowercaseChecker
                              ? "#008000"
                              : "#DC3545",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_MIN_LOWERCASE")}
                      </span>
                      <span
                        style={{
                          color:
                            this.state.gradPassword && minOneNumberChecker
                              ? "#008000"
                              : "#DC3545",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_MIN_NUMBER")}
                      </span>
                      <span
                        style={{
                          color:
                            this.state.gradPassword && minOneSpecialChecker
                              ? "#008000"
                              : "#DC3545",
                        }}
                      >
                        {i18n.t("validations.VALIDATE_MIN_SPECIAL_CHARACTER")}
                      </span>
                    </div>
                  )}
                </div>
              </div>
          
              {/* Actions (mirror Valert’s behavior) */}
              <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    const mainUser = this.loggedInUser;
                    this.props.graduateUserSubmit(
                      mainUser._id,
                      this.state.gradMail,
                      this.state.gradPassword,
                      this.state.selectedUserId
                    );
                  }}
                  disabled={
                    this.state.gradMail &&
                      this.state.gradPassword &&
                      !Validations.email(this.state.gradMail) &&
                      min8Checker &&
                      minOneLowercaseChecker &&
                      minOneNumberChecker &&
                      minOneSpecialChecker &&
                      minOneUppercaseChecker
                      ? false
                      : true
                  }
                >
                  {t("general.SUBMIT")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.setState({ gradMail: "", gradPassword: "", gradModal: false });
                  }}
                >
                  {t("general.CANCEL")}
                </button>
              </div>
            </form>
          }
          closeFunc={() =>
            this.setState({ gradMail: "", gradPassword: "", gradModal: false })
          }
        />
        <Vmodal
          displayStatus={this.props.saveSuccess}
          data={
            <div>
              <h4>{t("profile.PROFILE_SAVE_TITLE")}</h4>
              <p>{t("profile.PROFILE_SAVE_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearPrompt();
            window.location.reload();
          }}
          timedClose={2000}
        />
        <Valert
          display={this.props.saveSuccessUpdate}
          title={t("profile.PROFILE_SUCCESSFULLY_UPDATED_TITLE")}
          question={t("profile.PROFILE_SUCCESSFULLY_UPDATED_TEXT")}
          positiveAction={() => {
            let lang_code = this.props.subUserCreateForm.selectedLanguage;
            i18n.locale = lang_code;
            localStorage.setItem("i18nextLng", lang_code);
            sessionStorage.setItem("i18nextLng", lang_code);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.languageUpdated}
          title={t("profile.PROFILE_SUCCESSFULLY_UPDATED_TITLE")}
          question={t("profile.PROFILE_SUCCESSFULLY_UPDATED_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Vmodal
          displayStatus={this.props.gradSuccess}
          data={
            <div className="mb-4">
              <h4>{t("profile.GRADUATE_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("profile.GRADUATE_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearPrompt();
            this.setState({ gradMail: "", gradPassword: "", gradModal: false });
            window.location.reload();
          }}
          timedClose={2000}
        />
        <Valert
          display={false}
          title={t("profile.INCOMPLETE_NEW_PROFILE_TITLE")}
          question={t("profile.INCOMPLETE_NEW_PROFILE_TEXT")}
          onRef={(ref) => (this.incompleteNewUser = ref)}
          positiveAction={() => {
            this.userItemOnPosClick();
          }}
        />
        <Valert
          display={false}
          title={t("profile.PROFILE_NOT_SAVED_TITLE")}
          question={t("profile.PROFILE_NOT_SAVED_TEXT")}
          onRef={(ref) => (this.unsavedCurrentItem = ref)}
          positiveAction={() => {
            this.userItemOnPosClick();
          }}
        />
        <Valert
          display={false}
          title={t("profile.UNSAVED_NEW_PROFILE_TITLE")}
          question={t("profile.UNSAVED_NEW_SUBUSER_TEXT_1")}
          onRef={(ref) => (this.unsavedNewSubUser = ref)}
          positiveAction={() => {
            this.userItemOnPosClick();
          }}
        />
        <Valert
          display={this.props.wrongPassError}
          title={t("profile.OLD_PASSWORD_ERROR_TITLE")}
          question={t("profile.OLD_PASSWORD_ERROR_TEXT")}
          readOnly={true}
          positiveText={t("general.OK_PROMPT_TEXT")}
        />
        <Valert
          display={this.props.emailError}
          title={t("profile.REGISTERED_EMAIL_ADDRESS_TITLE")}
          question={t("profile.REGISTERED_EMAIL_ADDRESS_TEXT", {
            email: this.state.gradMail,
          })}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={this.handleRegisteredEmailPromptOk}
          readOnly={true}
        />
        <Valert
          display={this.props.nameExist}
          title={t("profile.DUPLICATE_USERNAME_TITLE")}
          question={t("profile.DUPLICATE_USERNAME_TEXT")}
          readOnly={true}
          positiveText={t("general.OK_PROMPT_TEXT")}
        />
        <Valert
          display={false}
          title={
            this.props.isEditing
              ? t("profile.SAVE_RECORD_TITLE")
              : t("profile.SAVE_CONFIRMATION_TITLE")
          }
          question={
            this.props.isEditing
              ? t("profile.SAVE_RECORD_TEXT")
              : t("profile.SAVE_CONFIRMATION_TEXT")
          }
          onRef={(ref) => (this.saveValert = ref)}
          positiveAction={
            isEditing
              ? this.handleSubmitUpdate.bind(this)
              : this.handleSubmit.bind(this)
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.CLEAR_CONFIRMATION_TITLE")}
          question={t("profile.CLEAR_USER_TEXT")}
          onRef={(ref) => (this.clearValert = ref)}
          positiveAction={() => {
            this.props.resetPage();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.DUPLICATE_ENTRY_TITLE")}
          question={t("profile.DUPLICATE_ENTRY_PROMPT_TEXT")}
          onRef={(ref) => (this.allergenDup = ref)}
          readOnly={true}
          positiveText={t("general.OK_PROMPT_TEXT")}
        />
        <Valert
          display={false}
          title={t("general.WARNING_TITLE")}
          question={this.state.noIdValertMessage}
          onRef={(ref) => (this.noIdValert = ref)}
          positiveAction={() => {
            this.noValidation = true;
            this.handleSubmit();
          }}
        />

        <Valert
          display={false}
          title={t("general.DELETE_CONFIRMATION_TITLE")}
          question={t("general.DELETE_CONFIRMATION_TEXT")}
          onRef={(ref) => (this.EthDelAlert = ref)}
          positiveAction={() => {
            this.props.onChangeProfile({
              target: {
                name: "ethnicityDelete",
                value: this.EthDelitem,
              },
            });
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.DELETE_CONFIRMATION_TITLE")}
          question={t("general.DELETE_CONFIRMATION_TEXT")}
          onRef={(ref) => (this.AlgDelAlert = ref)}
          positiveAction={() => {
            this.props.onChangeProfile({
              target: {
                name: "allergenDelete",
                value: this.AlgDelitem,
              },
            });
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.props.isEditing && this.props.firstChange
              ? t("profile.PROFILE_NOT_SAVED_TITLE")
              : !this.props.isEditing && this.props.firstChange
                ? t("profile.UNSAVED_NEW_PROFILE_TITLE")
                : t("profile.USER_DELETE_WARNING_TITLE")
          }
          question={
            this.props.isEditing && this.props.firstChange
              ? t("profile.PROFILE_NOT_UPDATED_DELETE_TEXT")
              : !this.props.isEditing && this.props.firstChange
                ? t("profile.UNSAVED_NEW_PROFILE_DELETE_TEXT")
                : t("profile.SUBUSER_DELETE_WARNING_TEXT")
          }
          onRef={(ref) => (this.deleteValert = ref)}
          positiveAction={() => {
            // Any unsaved edits (main or sub user) → show Not Recoverable Warning next
            this.showDeleteUserRef.changeStatus(); // Step 2
          }}
          positiveText={
            this.props.isEditing && this.props.firstChange ||
            !this.props.isEditing && this.props.firstChange
              ? t("general.POSITIVE_PROMPT_TEXT")
              : t("general.DELETE")
          }
          negativeText={t("general.CANCEL")}
        />

        <Valert
          display={false}
          onRef={(ref) => (this.showDeleteUserRef = ref)}
          title={t("profile.USER_DELETE_WARNING_TITLE")}
          question={
            this.state.isSelfDelete
              ? t("profile.MAIN_USER_DELETE_WARNING_TEXT")
              : t("profile.SUBUSER_DELETE_WARNING_TEXT")
          }
          positiveAction={() => {
            this.setState({ userPass: "" });
            this.openDeleteModal();
          }}
          positiveText={t("general.DELETE")}
          negativeText={t("general.CANCEL")}
        />

        <Vmodal
          zIndex={9}
          displayStatus={this.state.deleteModal}
          closeFunc={this.closeDeleteModal}
          data={
            // marginLeft: 15, marginRight: 15, paddingTop: 20
            <div style={{ width: 360, paddingTop: 25 }}>

              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {this.state.isSelfDelete
                  ? t("profile.MAIN_USER_DELETE_CONFIRM_TITLE")
                  : t("profile.SUBUSER_DELETE_CONFIRM_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 16px 0", lineHeight: 1.4 }}>
                {this.state.isSelfDelete
                  ? t("profile.MAIN_USER_DELETE_CONFIRM_TEXT")
                  : t("profile.SUBUSER_DELETE_CONFIRM_TEXT")}
              </p>

              {/* Inline error */}
              {this.state.showPasswordError && (
                <div
                  style={{
                    color: "#DC3545",
                    textAlign: "right",
                    fontWeight: "bold",
                    marginBottom: 4,
                    marginTop: -6,
                    fontSize: "1em",
                  }}
                >
                  {t("validations.PASSWORD")}
                </div>
              )}

              {/* Password field with eye toggle */}
              <div style={{ position: "relative" }}>
                <InputText
                  key={this.state.deletePassFieldId}
                  id={this.state.deletePassFieldId}
                  type={this.state.showPassword ? "text" : "password"}
                  invalid={graduatePassChecker(this.state.userPass)}
                  placeholder={t("general.PASSWORD")}
                  input={{
                    onChange: (e) =>
                      this.setState({
                        userPass: e.target.value,
                        showPasswordError: false,
                      }),
                    name: "userPass",
                    value: this.state.userPass,
                    autoComplete: "new-password",
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    spellCheck: false,
                  }}
                  meta={{ touched: true }}
                  style={{ borderColor: "#ced4da", boxShadow: "none", backgroundImage: "none", paddingRight: 36 }}
                />
                <div
                  style={{ position: "absolute", top: 5, right: 7, cursor: "pointer" }}
                  onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                >
                  <i
                    className={this.state.showPassword ? "far fa-eye" : "far fa-eye-slash"}
                    style={{ color: "#007bff" }}
                  />
                </div>
              </div>

              <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.onConfirmDeleteUser()}
                  disabled={this.state.userPass.length < 1}
                >
                  {t("general.SUBMIT")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.setState({ showPasswordError: false });
                    this.closeDeleteModal();
                  }}
                >
                  {t("general.CANCEL")}
                </button>
              </div>
            </div>
          }
        />
        <div
          className="grayList usersList"
          ref="users_container"
          style={{ flex: 1 }}
        >
          {allUsers &&
            allUsers.map((item, i) => {
              var mainShow = i == 0 ? "(main)" : "";
              let desc = `${item.first_name} ${item.last_name} ${mainShow} (${item._id})`;
              return (
                <div
                  className="usersItem"
                  key={i}
                  onClick={this.userItemOnClick.bind(this, i)}
                  style={{
                    paddingRight: "0px",
                  }}
                >
                  <Row
                    // className="wrapper"
                    className={"wrapper" + (item.isSelected ? " selected" : "")}
                  >
                    <Col
                      style={{
                        width: "80%",
                      }}
                    >
                      <span className="desc">{desc}</span>
                    </Col>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <i
                        className="far fa-trash-alt defIcon"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleDeleteUser(item._id);
                        }}
                        style={{
                          color: "#007bff",
                          marginRight: "5px",
                          padding: "2.5px",
                          fontSize: "15px",
                        }}
                      ></i>
                    </div>
                    {item._id !== this.props.mainUser._id && <div></div>}
                    <div className="clearfix" />
                  </Row>
                </div>
              );
            })}
        </div>
        <SubUserCreateForm
          t={t}
          onSubmit={
            isEditing
              ? this.handleSubmitUpdate.bind(this)
              : () => this.saveValert.changeStatus()
          }
          onDelete={() => this.deleteValert.changeStatus()}
          onCancel={() => this.clearValert.changeStatus()}
          ethnicities={ethnicities}
          locations={locations}
          isEditing={isEditing}
          isDeleting={isDeleting}
          gotoPath={this.props.history.push}
          onRef={(ref) => (this.FormRef = ref)}
          selectedUser={selectedUser}
          onChangeProfile={onChangeProfile}
          disabled={disabled}
          subUserCreateForm={subUserCreateForm}
          amountReseter={this.props.amountReseter}
          optionSelected={optionSelected}
          algModal={this.algModal}
          algModalStatus={this.state.algModalStatus}
          ethModal={this.ethModal.bind(this)}
          ethModalStatus={this.state.ethModalStatus}
          allergenDup={this.allergenDup}
          languageSelected={this.props.languageSelected}
          onGraduate={this.onGraduate}
          onDelAllergen={this.onDelAllergen.bind(this)}
          onDelEth={this.onDelEth.bind(this)}
          checkPassword={this.props.checkPassword}
        />
      </div>
    );
  }
}

Profile = translate("translations")(Profile);

const mapStateToProps = (state) => ({
  ...state.profile,
  ...state.subUserCreate,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...subUserCreateActions, ...profileUpdateActions, ...profileActions },
    dispatch
  );
export default connect(mapStateToProps, matchDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/pages/Profile.js